import {
  MacroTipoOnereDTO,
  getGetMacroTipiOnereQueryOptions,
  getMacroTipiOnere,
} from '@framework/api-client';
import { AsyncSelectInput, IBaseAsyncSelectInputProps } from '@framework/form';
import * as React from 'react';

export interface IMacroBurdenTypeSelectInputProps
  extends IBaseAsyncSelectInputProps {}

export function MacroBurdenTypeSelectInput(
  props: IMacroBurdenTypeSelectInputProps,
) {
  const { ...otherProps } = props;

  return (
    <AsyncSelectInput
      {...otherProps}
      queryFn={getMacroTipiOnere}
      queryOptions={getGetMacroTipiOnereQueryOptions}
      searchByField="denominazione"
      asOption={(type: MacroTipoOnereDTO) => ({
        value: type.id!,
        label: type.denominazione!,
        // disabled: disallowedIds?.includes(role.idUfficio!),
      })}
    />
  );
}
